import ProfileForm from "../components/user/ProfileForm";

function Profile() {
  return (
    <div className="page p-1">
      <ProfileForm />
    </div>
  );
}

export default Profile;
